const AnswerCounter = ({ answer }) => {
    return (
        answer?.answer?.other_details?.showCounter == false ? null : <p className="m-0 themeBlue">
            {answer?.answer?.answer || "--"}
        </p>
    )
}

export default AnswerCounter;